export default "__VITE_ASSET__BAXT4vWy__"